import { useQuery } from '@tanstack/react-query';
import { GetBankInfo, UserWalletTransactionService } from 'services/openapi';

import { TransactionServiceKeys } from './constants';

export const useGetBankInfoQuery = (locale = 'vi') => {
  const queryKey = [TransactionServiceKeys.GET_BANK_INFO];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetBankInfo, Error>({
    queryKey,
    queryFn: () =>
      UserWalletTransactionService.transactionControllerGetBankInfo(locale),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
